import {
  borderedInputWhite,
  label,
} from "../../../../shared/styles";
import globalState from "../../../../store";
import { useAtom } from "jotai";
import { useEffect, useState } from "react";
import {
  IProphoneContact,
} from "./types";
import { getProphoneContacts } from "./utils";

const RETOOL_CHECKOUT_LINK = process.env.REACT_APP_RETOOL_CHECKOUT_URL || "";

const CheckoutLink: React.FC = () => {
  const [globalStateAtom, setGlobalState] = useAtom(globalState);

  const [proPhoneContacts, setProPhoneContacts] = useState<IProphoneContact[]>(
    []
  );
  const [selectedProphoneContact, setSelectedProphoneContact] = useState(
    globalStateAtom?.prophone_contact_id || ""
  );

  useEffect(() => {
    getProphoneContacts().then((contacts) => setProPhoneContacts(contacts));
  }, []);

  return (
    <>
      <div className="mt-12 flex flex-col justify-start items-start bg-white p-6 rounded-lg">
        <div className="text-h1 font-bold">Checkout Link</div>

        {RETOOL_CHECKOUT_LINK && (
          <a
            className="my-4 bg-blue-600 hover:bg-blue-700 text-white py-4 px-8 rounded-md text-center self-start"
            target="_blank"
            rel="noopener noreferrer"
            href={RETOOL_CHECKOUT_LINK}
          >
            Generate Checkout Link
          </a>
        )}

        <label className={`${label} pb-1 w-full`}>
          Contact
          <select
            onChange={(e) => {
              setSelectedProphoneContact(e.target.value);
              setGlobalState({
                ...globalStateAtom,
                prophone_contact_id: e.target.value,
              });
            }}
            value={selectedProphoneContact}
            className={`${borderedInputWhite} flex py-2 pb-3`}
          >
            <option className="hidden" selected>
              Please Select Contact
            </option>
            {proPhoneContacts &&
              proPhoneContacts.length > 0 &&
              proPhoneContacts.map((contact) => {
                return (
                  <option key={contact.display_id} value={contact.display_id}>
                    {contact.display_name}
                  </option>
                );
              })}
          </select>
        </label>

        <label className={`${label} pb-1 w-full`}>
          Salesloft ID
          <input
            className={`${borderedInputWhite} flex py-2 pb-3`}
            type="number"
            onChange={(e) =>
              setGlobalState({
                ...globalStateAtom,
                salesloft_id: e.target.value,
              })
            }
            value={globalStateAtom?.salesloft_id}
          />
        </label>
      </div>
    </>
  );
};

export default CheckoutLink;
